import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import AddRecordButton from '@components/AddRecordButton';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import ShareCollectionButton from '@components/ShareButton/ShareCollectionButton';

import { ADD_GENETIC_INFORMATION } from '@constants/routes';

import { useGetGeneticInformation } from '@hooks/api/genetic-information';
import { useSession } from '@hooks/useSession';

import { ShareType } from 'generated/types';

import GeneticList from './Main';

const messages = defineMessages({
  addRecord: {
    id: 'geneticInformationPage.addRecord',
    defaultMessage: 'Add a Record',
  },
});

const GeneticInformationPage: React.FC<RouteComponentProps> = () => {
  const { data, loading } = useGetGeneticInformation();

  const { formatMessage } = useIntl();
  const {
    state: { isClient },
  } = useSession();

  const button = isClient ? (
    <AddRecordButton link={ADD_GENETIC_INFORMATION}>
      {formatMessage(messages.addRecord)}
    </AddRecordButton>
  ) : null;

  return (
    <>
      <ShareCollectionButton share_type={ShareType.GeneticInformation} />
      <GeneticList data={data} footer={button} loading={loading} />
    </>
  );
};

export default withErrorBoundary(GeneticInformationPage, {
  FallbackComponent: ErrorBoundaryFallback,
});
